// Module
var code = "<a data-bind=\"click: $data.SelectRow, css:{'enlarge': _hasEnlargeMiniFlow}\" ref=\"javascript:;\"><i class=\"fa fa-arrow-right\"></i></a>";
// Exports
export default code;